export function updateUrlParameter(param, value, alternativeUrl = null) {
    const url = alternativeUrl || window.location.href;
    const index = url.indexOf("?");
    if (index > 0) {
        const u = url.substring(index + 1).split("&");
        const params = new Array(u.length);
        let found = false;
        for (let i = 0; i < u.length; i++) {
            params[i] = u[i].split("=");
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (params[i][0] === param) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
                params[i][1] = value;
                found = true;
            }
        }
        if (!found) {
            params.push(new Array(2));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            params[params.length - 1][0] = param;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
            params[params.length - 1][1] = value;
        }
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands,@typescript-eslint/no-unsafe-member-access
        let res = url.substring(0, index + 1) + params[0][0] + "=" + params[0][1];
        for (let i = 1; i < params.length; i++) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/restrict-plus-operands
            res += "&" + params[i][0] + "=" + params[i][1];
        }
        return res;
    }
    else {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return url + "?" + param + "=" + value;
    }
}
export function updateUrlParam(param, value, alternativeUrl = null) {
    const url = alternativeUrl || window.location.href;
    const urlParts = url.split('?');
    const urlParams = urlParts[1];
    if (!urlParams) {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return url + '?' + param + '=' + value;
    }
    const urlParamList = urlParams.split('&');
    const paramsObj = {};
    urlParamList.forEach(urlParamItem => {
        const keyValuePair = urlParamItem.split('=');
        paramsObj[keyValuePair[0]] = keyValuePair[1];
    });
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    paramsObj[param] = value;
    return createUrlParamsString(paramsObj, url);
}
export function createUrlParamsString(paramsObj, alternativeUrl = null) {
    const url = alternativeUrl || window.location.href;
    const urlParts = url.split('?');
    const urlBeforeParams = urlParts[0];
    const paramList = [];
    const params = Object.entries(paramsObj);
    params.forEach(([key, value]) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        if (![undefined, null, NaN, ''].includes(value)) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            paramList.push(`${key}=${value}`);
        }
    });
    if (!paramList.length) {
        return urlBeforeParams;
    }
    return `${urlBeforeParams}?${paramList.join('&')}`;
}
export function getIdFromSlug(value) {
    if (typeof value !== 'string')
        return null;
    const split = value.split('-', 1);
    if (split.length === 1) {
        return Number(split[0]);
    }
    return null;
}
